import { FC } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { UserNotificationOutcome } from '@shared/apis/notifications';
import { Badge, BADGE_SIZE, BADGE_THEME } from '@shared/components/badge';
import { TooltipDelay } from '@shared/components/tooltip';
import { TruncatedTooltip } from '@shared/components/truncated-tooltip';
import { ResolvedNotificationHistoryItem } from '@shared/types/notifications';

import { NotificationTypeIcon } from '../notification-type-icon';
import { styles } from './NotificationHistoryItem.styles';
import { formatRelativeTime } from '../../../../Notifications.utils';

const OUTCOME_BADGE_THEME: Record<UserNotificationOutcome, BADGE_THEME> = {
  actioned: BADGE_THEME.green,
  dismissed: BADGE_THEME.orange,
  expired: BADGE_THEME.grey,
};

export interface NotificationHistoryItemProps extends WithStyles<typeof styles> {
  notification: ResolvedNotificationHistoryItem;
}

const NotificationHistoryItemComponent: FC<NotificationHistoryItemProps> = ({ classes, notification }) => {
  return (
    <div className={classes.root}>
      <NotificationTypeIcon type={notification.notificationType} />
      <div className={classes.main}>
        <div className={classes.headerRow}>
          <TruncatedTooltip classes={{ root: classes.title }} delay={TooltipDelay.Delayed} text={notification.title} />
          <span className={classes.time}>{formatRelativeTime(notification.createdAt)}</span>
        </div>
        <span className={classes.message}>{notification.message}</span>
        {notification.subtext && <span className={classes.subtext}>{notification.subtext}</span>}
        <div className={classes.badgeRow}>
          <Badge
            size={BADGE_SIZE.small}
            text={notification.outcomeLabel}
            theme={OUTCOME_BADGE_THEME[notification.outcome]}
          />
        </div>
      </div>
    </div>
  );
};

export const NotificationHistoryItem = withStyles(styles)(NotificationHistoryItemComponent);
